module.exports = __webpack_public_path__ + "static/img/14001034.bfea8f1f.png";